export default class PackagingController {
    constructor($scope, $injector) {
        this.$scope = $scope;

        this.packingDaisyService = $injector.get('packingDaisyService');
        this.numberFormatService = $injector.get('numberFormatService');
        this.Flash = $injector.get('Flash');
        this.$http = $injector.get('$http');
        this.$uibModal = $injector.get('$uibModal');
        this.$cookies = $injector.get('$cookies');
        this.$timeout = $injector.get('$timeout');
        this.$window = $injector.get('$window');

        this.boot();
    }

    boot() {
        this.modes = {
            'info': false,
            'subset': false,
            'all': false
        };

        this.infoModeItem = false;
        this.infoModePacking = false;
        this.currentPackingSlip = false;

        this.columnModes = {
            1: false,
            2: false
        };

        this.registerListeners();
        $(document).ready(this.initJQuery);
    }

    registerListeners() {
        this.$scope.$on('droppedAvailableItem', (event, payload) => this.droppedAvailableItem(event, payload));
        this.$scope.$on('droppedPackagedItem', (event, payload) => this.droppedPackagedItem(event, payload));
        this.$scope.$on('clickedItem', (event, item) => this.clickedItem(event, item));
        this.$scope.$on('clickedPackingInfoButton', (event, packing) => this.clickedPackingInfoButton(event, packing));
        this.$scope.$on('toggledPacking', (event, packing) => this.toggledPacking(event, packing));
        this.$scope.$on('addedNewPackagingMean', (event, packingMean) => this.addedNewPackagingMean(event, packingMean));
        this.$scope.$on('changedPackagingMean', (event, packingMean) => this.changedPackagingMean(event, packingMean));
        this.$scope.$on('duplicatedPackaging', (event, numberOfDuplicates) => this.duplicatedPackaging(event, numberOfDuplicates));
        this.$scope.$on('otherPackageAdded', (event, payload) => this.otherPackageAdded(event, payload));
    }

    fillViewWithData(data){
        let openPackingId = this.$cookies.get('openPackingId');

        this.currentPackingSlip = data.PACKING_SLIP;
        this.availableItems = data.PACKING_SLIP_ITEMS;
        this.packages = data.PACKAGES;
        this.availableItemsTexts = data.PACKING_SLIP_ITEMS_TEXTS;
        let packingToOpen = false;
        this.packages.map(function(packing){
            if (typeof openPackingId != 'undefined'){
                if (openPackingId == packing.PACKAGE_ID){
                    packingToOpen = packing;
                }
            }

            packing.status = {
                open: false,
                info: false
            }
        });
        
        if (packingToOpen != false){
            this.toggledPacking(false, packingToOpen);
        }
    }

    reload(){
        this.$window.location.reload();
    }

    addedNewPackagingMean(event, packingMean){
        let currentPackages = this.packages;
        this.packingDaisyService.newPackage(packingMean, this.currentPackingSlip).then((response) => {
            response.PACKAGES.map((packing) => {
                if (this.findPosition(this.packages, packing.PACKAGE_ID, 'PACKAGE_ID') == -1){
                    this.$cookies.put('openPackingId', packing.PACKAGE_ID);
                }
            });

            this.Flash.create('success', 'Neues Packstück hinzugefügt.');
            this.fillViewWithData(response);
        });
    }

    changedPackagingMean(event, packingMean){
        let newPacking = angular.copy(this.infoModePacking);
        newPacking.HEIGHT_IN_CM = packingMean.HEIGHT;
        newPacking.WIDTH_IN_CM = packingMean.WIDTH;
        newPacking.LENGTH_IN_CM = packingMean.LENGTH;
        newPacking.PACKAGING_MEAN_ID = packingMean.ID;
        this.packingDaisyService.changePackage(newPacking, this.currentPackingSlip).then((response) => {
            let updatedPacking = this.findValue(response.PACKAGES, newPacking.PACKAGE_ID, 'PACKAGE_ID');

            this.infoModePacking = angular.copy(updatedPacking);
            this.infoModePacking.TARA_WEIGHT = this.numberFormatService.formatNumberToString(this.infoModePacking.TARA_WEIGHT);
            this.infoModePacking.GROSS_WEIGHT = this.numberFormatService.formatNumberToString(this.infoModePacking.TARA_WEIGHT);

            this.fillViewWithData(response);
            updatedPacking.status.info = true;
            this.Flash.create('success', 'Packstück getauscht.');
        });
    }

    duplicatedPackaging(event, numberOfDuplicates){
        this.packingDaisyService.duplicatePackage(this.infoModePacking, this.currentPackingSlip, numberOfDuplicates).then((response) => {
            let updatedPacking = this.findValue(response.PACKAGES, this.infoModePacking.PACKAGE_ID, 'PACKAGE_ID');

            this.infoModePacking = angular.copy(updatedPacking);
            this.infoModePacking.TARA_WEIGHT = this.numberFormatService.formatNumberToString(this.infoModePacking.TARA_WEIGHT);
            this.infoModePacking.GROSS_WEIGHT = this.numberFormatService.formatNumberToString(this.infoModePacking.TARA_WEIGHT);

            this.fillViewWithData(response);
            updatedPacking.status.info = true;
            this.Flash.create('success', 'Packstück dupliziert.');

        });
    }

    findPosition(searchArray, value, keyName = 'id') {
        return _.findIndex(searchArray, [keyName, value]);
    }

    findValue(searchArray, value, keyName){
        let position = this.findPosition(searchArray, value, keyName);
        return searchArray[position];
    }

    openCommentModal(itemAndQuantityArray){
        let modalScope = this.$scope.$new(true);
        modalScope.params = {
            items: itemAndQuantityArray
        };
        let modalInstance = this.$uibModal.open({
            scope: modalScope,
            animation: true,
            templateUrl: 'angular/modules/commentModal.html',
            controller: 'CommentModalController',
            controllerAs: 'vm',
            size: 'lg'
        });

        return modalInstance.result;
    }

    moveItems(itemAndQuantityArray, packingId){
        this.packingDaisyService.addItemsToPackage(this.currentPackingSlip, packingId, itemAndQuantityArray).then((response) => {
            this.Flash.create('success', 'Artikel verschoben.');
            this.fillViewWithData(response);
        });
    }

    checkItemsForCommentAndTextAfterPos(itemAndQuantityArray){
        let textAvailable = false;
        _.forEach(itemAndQuantityArray, (value, key) => {
            if (value.item.COMMENT.trim() !== ''){
                textAvailable = true;

            }

            if (value.item.TEXT_AFTER_POS.trim() !== ''){
                textAvailable = true;
            }
        });
        return textAvailable;
    }

    checkForCommentsAndMoveItems(itemAndQuantityArray, packingId){
        let textAvailable = this.checkItemsForCommentAndTextAfterPos(itemAndQuantityArray);

        if (textAvailable){
            this.openCommentModal(itemAndQuantityArray).then((message)  => {
                this.moveItems(itemAndQuantityArray, packingId);

            }, ()=>{
                //
            });

        }
        else{
            return this.moveItems(itemAndQuantityArray, packingId);
        }
    }

    moveAllItems(payload) {
        let itemAndQuantityArray = [];
        _.forEach(this.availableItems, (item, key) => {
            if (item.COMMISSIONED_QTY - item.PACKED_QTY <= 0){
                return;
            }

            item.editComment = false;
            item.originalCOMMENT = item.COMMENT;
            item.editTextAfterPos = false;
            item.originalTEXT_AFTER_POS = item.TEXT_AFTER_POS;


            itemAndQuantityArray.push({
                item: angular.copy(item),
                qty: item.COMMISSIONED_QTY - item.PACKED_QTY,
                qty_unit_id: item.QTY_UNIT_ID
            });
        });
        this.checkForCommentsAndMoveItems(itemAndQuantityArray, payload.packingId);
    }

    moveItem(payload) {
        let itemPosition = this.findPosition(this.availableItems, payload.itemId, 'PACKING_SLIP_ITEM_ID');
        let item = angular.copy(this.availableItems[itemPosition]);
        item.editComment = false;
        item.originalCOMMENT = item.COMMENT;
        item.editTextAfterPos = false;
        item.originalTEXT_AFTER_POS = item.TEXT_AFTER_POS;

        let itemAndQuantityArray = [
            {
                item: item,
                qty: item.COMMISSIONED_QTY - item.PACKED_QTY,
                qty_unit_id: item.QTY_UNIT_ID
            }
        ];
        this.checkForCommentsAndMoveItems(itemAndQuantityArray, payload.packingId);
    }

    openSubsetModal(modalScope){
        var modalInstance = this.$uibModal.open({
            scope: modalScope,
            animation: true,
            templateUrl: 'angular/modules/subsetModal.html',
            controller: 'SubsetController',
            controllerAs: 'vm',
            size: 'lg'
        });

        return modalInstance.result;
    }

    checkForSubset(subsetString){
        if (subsetString.trim() == ''){
            this.Flash.create('warning', 'Keine Teilmenge eingegeben!');
            return false;
        }
        return true;
    }

    doSubsetDrop(payload){
        let item = this.findValue(this.availableItems, payload.itemId, 'PACKING_SLIP_ITEM_ID');
        let packing = this.findValue(this.packages, payload.packingId, 'PACKAGE_ID');

        item = angular.copy(item);

        item.editComment = false;
        item.originalCOMMENT = item.COMMENT;
        item.editTextAfterPos = false;
        item.originalTEXT_AFTER_POS = item.TEXT_AFTER_POS;

        var modalScope = this.$scope.$new(true);
        modalScope.params = {
            item: item,
            mode: 'available'
        };

        this.openSubsetModal(modalScope).then((message) => {
            if (!this.checkForSubset(message)){
                return;
            }

            let itemAndQuantityArray = [
                {
                    item: item,
                    qty: parseFloat(message),
                    qty_unit_id: item.QTY_UNIT_ID
                }
            ];
            this.moveItems(itemAndQuantityArray, payload.packingId);
        });
    }

    droppedAvailableItem(event, payload) {
        if (this.modes.all) {
            return this.moveAllItems(payload);
        }
        if (this.modes.subset) {
            return this.doSubsetDrop(payload);
        }

        return this.moveItem(payload);
    }

    doPackedSubsetDrop(payload){
        let packing =  this.findValue(this.packages, payload.packingId, 'PACKAGE_ID');
        let item = this.findValue(packing.PACKAGE_ITEMS, payload.itemId, 'PACKING_SLIP_ITEM_ID');

        var modalScope = this.$scope.$new(true);
        modalScope.params = {
            item: item,
            mode: 'packed'
        };

        this.openSubsetModal(modalScope).then((message) => {
            if (!this.checkForSubset(message)){
                return;
            }

            let itemAndQuantityArray = [
                {
                    item: item,
                    qty: parseFloat(message),
                    qty_unit_id: item.QTY_UNIT_ID
                }
            ];
            this.movePackedItems(itemAndQuantityArray, payload.packingId);
        });
    }

    movePackedItems(itemAndQuantityArray, packingId){
        this.packingDaisyService.removePackageItems(this.currentPackingSlip, packingId, itemAndQuantityArray).then((response) => {
            this.Flash.create('success', 'Artikel verschoben.');
            this.fillViewWithData(response);
        });
    }

    moveAllPackedItems(payload) {
        let packingPosition = this.findPosition(this.packages, payload.packingId, 'PACKAGE_ID');
        let packing = this.packages[packingPosition];

        // TODO: only available items
        let itemAndQuantityArray = [];
        _.forEach(packing.PACKAGE_ITEMS, (value, key) => {
            itemAndQuantityArray.push({
                item: value,
                qty: value.QTY,
                qty_unit_id: value.QTY_UNIT_ID
            });
        });

        this.movePackedItems(itemAndQuantityArray, payload.packingId);
    }

    movePackedItem(payload) {
        let packingPosition = this.findPosition(this.packages, payload.packingId, 'PACKAGE_ID');
        let packing = this.packages[packingPosition];
        var itemPosition = this.findPosition(packing.PACKAGE_ITEMS, payload.itemId, 'PACKING_SLIP_ITEM_ID');
        let item = packing.PACKAGE_ITEMS[itemPosition];

        let itemAndQuantityArray = [
            {
                item: item,
                qty: item.QTY,
                qty_unit_id: item.QTY_UNIT_ID
            }
        ];
        this.movePackedItems(itemAndQuantityArray, payload.packingId);
    }

    droppedPackagedItem(event, payload){
        if (this.modes.all) {
            return this.moveAllPackedItems(payload);
        }
        if (this.modes.subset) {
            return this.doPackedSubsetDrop(payload);
        }

        return this.movePackedItem(payload);
    }

    clickedItem(event, item) {
        if (this.modes.info) {
            this.infoModeItem = item;
        }
    }

    changeMode(mode) {
        var toggledValue = !this.modes[mode];

        this.modes.all = false;
        this.modes.subset = false;
        this.modes.info = false;

        this.modes[mode] = toggledValue;
    }

    changePackingSlip(packingSlipNumber){
        packingSlipNumber = packingSlipNumber.trim();
        if (packingSlipNumber == ''){
            this.packingSlipNumber = '';
            this.modes.all = false;
            this.modes.subset = false;
            this.modes.info = false;

            this.infoModeItem = false;
            this.infoModePacking = false;

            this.currentPackingSlip = false;
            this.availableItems = false;
            this.packages = false;
            return this.changeColumnMode(2, 'none');
        }

        this.packingDaisyService.getPackingSlip(packingSlipNumber).then((response) => {
            if (response === false){
                return this.changeColumnMode(2, 'none');
            }

            this.packingSlipNumber = packingSlipNumber;
            $('#packingSlip').val(packingSlipNumber);

            this.fillViewWithData(response);

            if (this.currentPackingSlip.COMMENT.trim() != ''){
                this.columnModes[2] = 'packingSlipInfos';
            }
            else{
                this.columnModes[2] = 'items';
            }

            this.Flash.create('success', 'Packzettel ' + packingSlipNumber + ' geladen.');
        });
    }

    closePackingSlip(){
        this.changePackingSlip('');
        this.Flash.create('success', 'Packzettel geschlossen.');
    }

    changeShowPackingSlipInfo(){
        if (this.currentPackingSlip === false){
            return;
        }
        this.resetPackagesInfoMode();

        if (this.columnModes[2] == 'packingSlipInfos'){
            this.changeColumnMode(2, 'items');
        }
        else{
            this.changeColumnMode(2, 'packingSlipInfos');
        }
    }

    checkForPackingChangesAndHandleModal(){
        let currentPackingToCheck = angular.copy(this.infoModePacking);
        if (this.getPackingSaveButtonClass(currentPackingToCheck) == 'btn-success'){
            this.openPackingSaveModal(currentPackingToCheck).then((message) => {
                currentPackingToCheck.TARA_WEIGHT = this.numberFormatService.formatStringToNumber(currentPackingToCheck.TARA_WEIGHT);
                currentPackingToCheck.GROSS_WEIGHT = this.numberFormatService.formatStringToNumber(currentPackingToCheck.GROSS_WEIGHT);
                this.packingDaisyService.changePackage(currentPackingToCheck, this.currentPackingSlip).then((response) => {
                    this.Flash.create('success', 'Änderungen gespeichert.');
                    this.fillViewWithData(response);
                });
            }, ()=>{
                // aborted
            });
        }
    }

    changeColumnMode(column, newMode){
        if (column == 2 && this.columnModes[column] == 'packageInfos'){
            this.checkForPackingChangesAndHandleModal();
        }

        if (column == 2){
            if (newMode != 'packageInfos') {
                this.resetPackagesInfoMode();
            }
        }
        this.columnModes[column] = newMode;
    }

    resetPackagesInfoMode(){
        if (this.packages) {
            this.packages.map(function (packing) {
                packing.status.info = false;
            });
        }
    }

    openPackingInfo(packing){
        this.resetPackagesInfoMode();
        this.changeColumnMode(2, 'packageInfos');
        packing.status.info = true;
        this.infoModePacking = angular.copy(packing);
        this.infoModePacking.TARA_WEIGHT = this.numberFormatService.formatNumberToString(this.infoModePacking.TARA_WEIGHT);
        this.infoModePacking.GROSS_WEIGHT = this.numberFormatService.formatNumberToString(this.infoModePacking.GROSS_WEIGHT);
    }

    clickedPackingInfoButton(event, packing){
        let currentPackingStatus = packing.status.info;

        if (currentPackingStatus == false){
            this.openPackingInfo(packing);
            packing.status.open = false;
            this.toggledPacking(false, packing);
        }
        else{
            this.changeColumnMode(2, 'items');
            this.infoModePacking = false;
        }
    }

    toggledPacking(event, packing){
        this.$cookies.remove('openPackingId');
        let newStatusOpen = !packing.status.open
        packing.status.open = newStatusOpen;
        if (!newStatusOpen) {
            return;
        }

        let packingPosition = this.findPosition(this.packages, packing.PACKAGE_ID, 'PACKAGE_ID');
        this.packages.splice(packingPosition, 1);
        this.packages.unshift(packing);
        this.$cookies.put('openPackingId', packing.PACKAGE_ID);

        $('.left-item-container').animate({ scrollTop: "0px" });

        if (this.showInColumn(2, 'packageInfos')){
            this.openPackingInfo(packing);
        }
    }

    showInColumn(columnNumber, type) {
        return this.columnModes[columnNumber] == type;
    }

    deletePacking(packing){
        this.packingDaisyService.deletePackage(packing.PACKAGE_ID, this.currentPackingSlip).then((response) => {
            this.Flash.create('success', 'Packstück gelöscht.');
            this.fillViewWithData(response);
            let openPackageId = this.$cookies.get('openPackingId');
            if (typeof openPackageId != 'undefined') {
                if (packing.PACKAGE_ID == openPackageId) {
                    this.$cookies.remove('openPackingId');
                }
            }

            this.infoModePacking = false;
            this.changeColumnMode(2, 'items');
        });
    }

    printPackage(packing){
        this.packingDaisyService.printPackage(packing.PACKAGE_ID).then((response) => {
            let message = 'Inhaltsetikett für das Packstück "' + packing.PACKAGE_NUMBER + '" erfolgreich gedruckt.';
            this.Flash.create('success', message);
        });
    }

    printPackingSlip(){
        this.packingDaisyService.printPackingSlip(this.packages).then((response) => {
            let message = 'Inhaltsetiketten erfolgreich gedruckt.';
            this.Flash.create('success', message);
        });
    }

    savePackingSlipItemComment(infoModeItem){
        this.packingDaisyService.savePackingSlipItemComment(this.infoModeItem, this.currentPackingSlip).then((response) => {
            let message = 'Kommentar erfolgreich gespeichert.';
            this.Flash.create('success', message);
        });
    }

    savePackingSlipItemTextAfterPos(infoModeItem){
        this.packingDaisyService.savePackingSlipItemTextAfterPos(this.infoModeItem, this.currentPackingSlip).then((response) => {
            let message = 'Text nach Position erfolgreich gespeichert.';
            this.Flash.create('success', message);
        });
    }

    getPackingSaveButtonClass(packing){
        if(!packing){
            return '';
        }


        let packingBeforeChanges = this.findValue(this.packages, packing.PACKAGE_ID, 'PACKAGE_ID');

        let TARA_WEIGHT = this.numberFormatService.formatStringToNumber(packing.TARA_WEIGHT);
        if (packingBeforeChanges.DESCRIPTION != packing.DESCRIPTION){
            return 'btn-success';
        }
        if (parseFloat(packingBeforeChanges.TARA_WEIGHT) != parseFloat(TARA_WEIGHT)){
            return 'btn-success';
        }
        else if (parseInt(packingBeforeChanges.LENGTH_IN_CM) != parseInt(packing.LENGTH_IN_CM)){
            return 'btn-success';
        }
        else if (parseInt(packingBeforeChanges.WIDTH_IN_CM) != parseInt(packing.WIDTH_IN_CM)){
            return 'btn-success';
        }
        else if (parseInt(packingBeforeChanges.HEIGHT_IN_CM) != parseInt(packing.HEIGHT_IN_CM)){
            return 'btn-success';
        }

        return 'btn-default';
    }

    savePackingChanges(packing){
        // copy the packing here because we change the number format to valid float
        // if we change the original the view will be updated with the float until the data is back from daisy
        let copyOfPacking = angular.copy(packing);
        copyOfPacking.TARA_WEIGHT = this.numberFormatService.formatStringToNumber(copyOfPacking.TARA_WEIGHT);
        copyOfPacking.GROSS_WEIGHT = this.numberFormatService.formatStringToNumber(copyOfPacking.GROSS_WEIGHT);
        this.packingDaisyService.changePackage(copyOfPacking, this.currentPackingSlip).then((response) => {
            this.Flash.create('success', 'Änderungen gespeichert.');
            this.fillViewWithData(response);
            let updatedPacking = this.findValue(response.PACKAGES, copyOfPacking.PACKAGE_ID, 'PACKAGE_ID');
            updatedPacking.status.info = true;
            this.infoModePacking = angular.copy(updatedPacking);
            this.infoModePacking.TARA_WEIGHT = this.numberFormatService.formatNumberToString(this.infoModePacking.TARA_WEIGHT);
            this.infoModePacking.GROSS_WEIGHT = this.numberFormatService.formatNumberToString(this.infoModePacking.GROSS_WEIGHT);
        });
    }

    openPackingSaveModal(packing){
        let modalScope = this.$scope.$new(true);
        let packingBeforeChanges = this.findValue(this.packages, packing.PACKAGE_ID, 'PACKAGE_ID');
        let copyOfPackingBeforeChanges = angular.copy(packingBeforeChanges);
        copyOfPackingBeforeChanges.TARA_WEIGHT = this.numberFormatService.formatNumberToString(copyOfPackingBeforeChanges.TARA_WEIGHT);

        modalScope.params = {
            packingBeforeChanges: copyOfPackingBeforeChanges,
            packingAfterChanges: packing,
        };

        let modalInstance = this.$uibModal.open({
            scope: modalScope,
            animation: true,
            templateUrl: 'angular/modules/packingSaveModal.html',
            controller: 'PackingSaveModalController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg'
        });

        return modalInstance.result;
    }

    openFinishPackingSlipModal(shippingTypes,changeShippingTypeAllowed){
        let modalScope = this.$scope.$new(true);
        modalScope.params = {
            shippingTypes: shippingTypes,
            packingSlip: this.currentPackingSlip,
            changeShippingTypeAllowed: changeShippingTypeAllowed
        };
        let modalInstance = this.$uibModal.open({
            scope: modalScope,
            animation: true,
            templateUrl: 'angular/modules/finishPackingSlipModal.html',
            controller: 'FinishPackingSlipModalController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg'
        });

        return modalInstance.result;
    }

    finishPackingSlip() {
        this.packingDaisyService.getShippingTypes(this.currentPackingSlip).then((response) => {
            if(!('SHIPPING_TYPES' in response)) {
               return;
            }

            this.openFinishPackingSlipModal(response.SHIPPING_TYPES, response.CHANGE_SHIPPING_TYPE_ALLOWED).then((message) => {
                this.changePackingSlip('');
                let $packingSlipInput = $('#packingSlip');

                var keyboard = $packingSlipInput.getkeyboard();

                keyboard.reveal(true).insertText('');
                keyboard.$preview.val('');
                $('.ui-keyboard .ui-keyboard-preview-wrapper .ui-keyboard-preview').focus();

            }, ()=>{
                // aborted
            });
        });
    }

    otherPackageAdded(event, payload){
        this.fillViewWithData(payload);
    }

    initJQuery(){
        var keyboardPosition = {
            of: $('.keyboard-container'),
            my : 'center top',
            at : 'center top',
            at2: 'center bottom'
        };
        let $packingSlipInput = $('#packingSlip');

        $packingSlipInput.keyboard({
            layout: 'customnum',
            autoAccept : true,
            position: keyboardPosition
        });

        var keyboard = $packingSlipInput.getkeyboard();
        keyboard.reveal(true).insertText('');

        $('.ui-keyboard .ui-keyboard-preview-wrapper .ui-keyboard-preview').focus();
    }
}
